import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem, Message } from 'primeng/api';
import { IOrderImport } from '../../interfaces/upload-order/order-import';
import { FileUpload, MessageService } from 'primeng';
import { OrderImportService, UserService } from '../../services';

@Component({
  selector: 'order-upload',
  templateUrl: './order-upload.component.html',
  styleUrls: ['./order-upload.component.scss'],
  providers: [],
})
export class OrderUploadComponent implements OnInit {
  items: MenuItem[];
  activeIndex: number = 0;
  isUploadingFileToServer: boolean = false;
  progress: number = 0;
  showProgressBar: boolean = false;
  files: any;
  uploadedFilePath: string;
  selectedFile: any = null;
  fileData: IOrderImport[];
  @ViewChild('fileUploader') fileUploader: FileUpload;
  cols: any;
  processingMessage: string = 'Processing';
  sample_spreadsheet_file = '/assets/docs/spreadsheet_import_sample.csv';
  sample_spreadsheet_impersonating_file =
    '/assets/docs/spreadsheet_import_impersonating_sample.csv';
  isLoadingFileData: boolean = false;
  showOrderLimits: boolean = false;

  constructor(
    private messageService: MessageService,
    private orderImportService: OrderImportService,
    private userService: UserService,
  ) {}

  protected isImpersonating: boolean = false;

  ngOnInit() {
    this.initialiseSteps();

    this.userService.isUserImpersonating().then((res) => {
      if (res != null) {
        this.isImpersonating = res.isImpersonating;
      } else {
        this.isImpersonating = false;
      }
    });
  }

  initialiseSteps() {
    this.items = [
      {
        label: 'Upload',
        command: (event: any) => {
          this.activeIndex = 0;
        },
      },
      {
        label: 'Process',
        command: (event: any) => {
          this.activeIndex = 1;
        },
      },
      {
        label: 'Completed',
        command: (event: any) => {
          this.activeIndex = 2;
        },
      },
    ];
  }

  downloadSampleFile() {
    // this.orderImportService.downloadSampleCSVFile().subscribe(
    //     data =>{
    //         const blob = new Blob([data], { type: 'text/csv' });
    //         const url= window.URL.createObjectURL(blob);
    //         window.open(url);
    //     }
    // ), error =>{
    //     console.log('Error downloading file ')
    // },
    // () => console.log('Download completed!');
  }
}
